import Section from './Section';

class RubricBlock {
  private readonly _use: string;
  private readonly _view: string;
  private readonly _contentBody: string;
  private readonly _stylesheet: string;
  private _section!: Section;
  constructor(contentBody: string, stylesheet: string, view: string, use: string) {
    this._contentBody = contentBody;
    this._stylesheet = stylesheet;
    this._view = view;
    this._use = use;
  }

  get contentBody(): string {
    return this._contentBody;
  }

  get stylesheet(): string {
    return this._stylesheet;
  }

  get view(): string {
    return this._view;
  }

  get use(): string {
    return this._use;
  }

  set section(section: Section) {
    this._section = section;
  }

  get section(): Section {
    return this._section;
  }
}

export default RubricBlock;
